import { useEffect, useState } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Radio,
  IconButton,
  Typography,
  SelectChangeEvent,
} from "@mui/material";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

type props = {
  index?: number;
  selectedValue: string;
  value?: string;
  onRadioChange?: any;
  onDelete?: any;
  allUsers?: any[];
  selectedUsers?: any[];
  onValueChange?: any;
  isUserEmptyError?: boolean;
};

export default function AdditionalContactField({
  index,
  selectedValue,
  value,
  onRadioChange,
  onDelete,
  allUsers,
  selectedUsers,
  onValueChange,
  isUserEmptyError,
}: props) {
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    // on form submit check if user is empty, if yes show error
    if (isUserEmptyError && !value) {
      setError(true);
      setErrorMessage("This field can't be empty");
    }
  }, [isUserEmptyError]); // eslint-disable-line

  useEffect(() => {
    if (selectedUsers && selectedUsers.length > 0) {
      const valueArr = selectedUsers.map((item) => item.userId);
      const isDuplicate = valueArr.some(
        (item, idx) => valueArr.indexOf(item) !== idx
      );
      if (isDuplicate || isUserEmptyError) {
        setError(true);
      } else {
        setError(false);
        setErrorMessage("");
      }
    }
  }, [selectedUsers]); // eslint-disable-line

  const handleValueChange = (e: SelectChangeEvent<string>) => {
    onValueChange(e);
    const userId = e?.target?.value;
    if (isUserDuplicate(userId)) {
      setError(true);
    } else {
      setError(false);
      setErrorMessage("");
    }
  };

  const isUserDuplicate = (userId: string) => {
    let isDuplicate = false;
    selectedUsers?.forEach((user) => {
      if (userId === user.userId) {
        isDuplicate = true;
      }
    });
    if (isDuplicate) {
      setErrorMessage("Duplicate user not allowed.");
    }
    return isDuplicate;
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
      <Radio
        sx={{ mr: 2 }}
        checked={selectedValue === `contact${index}`}
        onChange={onRadioChange}
        value={`contact${index}`}
        name="radio-buttons"
        inputProps={{ "aria-label": "A" }}
      />
      <FormControl sx={{ width: "100%" }}>
        <InputLabel id="contact-select-label">Contact</InputLabel>
        <Select
          labelId="contact-select-label"
          id="contact-select"
          label="Contact"
          value={value}
          onChange={handleValueChange}
        >
          {allUsers?.map((user: any) => (
            <MenuItem value={user.id}>{user.fullName}</MenuItem>
          ))}
        </Select>
        {error && (
          <Typography color="error" sx={{ fontSize: 12, ml: 2, mt: 0.5 }}>
            {errorMessage}
          </Typography>
        )}
      </FormControl>
      {selectedValue !== `contact${index}` ? (
        <IconButton aria-label="delete" onClick={onDelete}>
          <DeleteOutlineOutlinedIcon style={{ color: "#D32F2F" }} />
        </IconButton>
      ) : (
        <Box sx={{ width: 46 }}></Box>
      )}
    </Box>
  );
}
